import { render, staticRenderFns } from "./confirmBidRecord.vue?vue&type=template&id=0d433fc3&scoped=true"
import script from "./confirmBidRecord.vue?vue&type=script&lang=js"
export * from "./confirmBidRecord.vue?vue&type=script&lang=js"
import style0 from "./confirmBidRecord.vue?vue&type=style&index=0&id=0d433fc3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d433fc3",
  null
  
)

export default component.exports